import * as types from './types';
import { integrations } from 'config';
import createReducer from '../../createReducer';

const initialState = {
  pristine: true,
  loading: false,
  settings: {
    core: null,
    loading: false,
    permissions: {},
    integrations: integrations,
  },
  lastFetched: null,
};

const userReducer = createReducer(initialState)({
  [types.FETCH_CONFIG_REQUEST]: (state) => {
    return {
      ...state,
      settings: {
        ...state.settings,
        loading: true,
      },
    };
  },
  [types.FETCH_CONFIG_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      settings: {
        ...payload,
        core: {
          ...payload.core,
          organization: {
            ...payload.core.organization,
            opt_out_enable: payload?.core?.organization?.hasOwnProperty('opt_out_enable') ? payload?.core?.organization?.opt_out_enable : true
          }
        },
        loading: false,
        integrations: {
          ...payload.integrations,
          dashboard_settings:
            payload?.integrations?.dashboard_settings || integrations.dashboard_settings,
        },
      },
      pristine: false,
      lastFetched: Date.now(),
    };
  },
  [types.FETCH_CONFIG_FAILED]: (state) => {
    return {
      ...state,
      settings: {
        ...state.settings,
        loading: false,
      },
      pristine: true,
      lastFetched: null,
    };
  },

  [types.FETCH_UPDATE_CONFIG_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_UPDATE_CONFIG_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      settings: {
        ...payload,
        integrations: {
          ...payload.integrations,
          dashboard_settings:
            payload?.integrations?.dashboard_settings || integrations.dashboard_settings,
        },
      },
      lastFetched: Date.now(),
      loading: false,
    };
  },
  [types.FETCH_UPDATE_CONFIG_FAILED]: (state) => {
    return {
      ...state,
      lastFetched: null,
      loading: false,
    };
  },

  [types.UPDATE_CONFIGURATION_PREFERENCES]: (state, { payload }) => {
    return {
      ...state,
      settings: payload,
    };
  },
});

export default userReducer;
